/**
 * CFK Cart Bundle Removal
 * When a car freshener kit is removed, also remove the bundled free oil
 */
(function () {
  'use strict';

  // Handle bundle removal
  document.addEventListener(
    'click',
    function (e) {
      // Check if clicked element is or is inside a quantity__remove link
      var removeLink = e.target.closest('.quantity__remove');
      if (!removeLink) return;

      // Check if this item is part of a bundle by looking at the parent container
      var container = removeLink.closest(
        '.cart-item-container, .cart__row, [data-cart-item]'
      );
      if (!container) return;

      // Check if container has bundle parent data
      var parentKey = container.getAttribute('data-cfk-parent');
      var childrenJson = container.getAttribute('data-cfk-children');

      // If no bundle data, allow default behavior (regular single item removal)
      if (!parentKey || !childrenJson) {
        return;
      }

      // This is a bundle item - prevent default removal
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var childKeys;
      try {
        childKeys = JSON.parse(childrenJson);
      } catch (err) {
        childKeys = [];
      }

      if (!Array.isArray(childKeys) || childKeys.length === 0) {
        childKeys = [];
      }

      // Build updates object to remove all items
      var updates = {};
      updates[parentKey] = 0; // Remove parent

      childKeys.forEach(function (childKey) {
        updates[childKey] = 0; // Remove each child
      });

      // Send update request
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates: updates }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          // Reload page to show updated cart
          window.location.reload();
        })
        .catch(function () {
          // Fallback: reload anyway
          window.location.reload();
        });
    },
    true
  );
})();
